/* generateEpgFilter.ts */
import Category from '@shared/classes/category';
import Rail from '../../classes/rail';
import DateUtils from '../date';
import { ICategory } from '../../types/interfaces/category';
import {
  RailDisplayMode,
  RailOrderSort,
  RailOrderType,
  RailType,
} from '../../types/enums/rail';

// Days to include before and after today in the EPG filter rail.
const EPG_DAYS_BEFORE = 7;
const EPG_DAYS_AFTER = 7;

export default function generateEpgFilter() {
  const filtersBase = {
    section: {
      presentationType: RailDisplayMode.FILTER,
      name: 'epgFilterRail',
    },
  };

  const today = new Date();
  const categories: Category[] = [];

  // Build one Category per day, covering EPG_DAYS_BEFORE days in the past through EPG_DAYS_AFTER days in the future.
  for (let offset = -EPG_DAYS_BEFORE; offset <= EPG_DAYS_AFTER; offset++) {
    const date = new Date(today);
    date.setDate(today.getDate() + offset);

    const startOfDay = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      0,
      0,
      0,
      0
    );
    const endOfDay = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      23,
      59,
      59,
      999
    );

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateId = `epg-day-${year}-${month}-${day}`;

    const baseCategory: ICategory = {
      id: dateId,
      created: startOfDay.toISOString(),
      updated: endOfDay.toISOString(),
      name: dateId,
      order: offset + EPG_DAYS_BEFORE,
      orderField: RailOrderType.DATE,
      orderSort: RailOrderSort.ASCENDING as unknown as RailOrderType,
      presentationType: RailDisplayMode.FILTER,
      title: DateUtils.getDayTitle(date),
    };
    categories.push(new Category(baseCategory));
  }

  return Rail.constructorWithData(filtersBase, categories, RailType.FILTER);
}
